import React from 'react'
import AllHospitals from '../../components/Doctors/AllHospitals'
const AllHospitalsPage = () => {
  return (
    <div>
      <AllHospitals/>
    </div>
  )
}

export default AllHospitalsPage
